//期間選択
import React, { Component, useState, useContext } from "react";
import { useEffect } from "react";
import { ShopContext } from "app/contexts/ShopContext";

//class ShopData extends Component {
export default function ShopData(props) {

    const { shops, setShops } = useContext(ShopContext)
    console.log('◆shops' + shops)
    //constructor(props) {
    //    super(props);

    //const [shops, setShops] = useState([]);
    //setShops(props)
    console.log('◆◇' + props.shops)
    //setShops(props.shops)

    const getShopList = () => {
        return shops
    }
    //}

    /*
    render() {
        return (
            <>
            </>

        );
    }
    */

    /*
    const HomeData = () => {
        if (pages == 'Home') {
            return (
                'ホームデータです'
            )
        }

    }
    */

    //const pages = (props.pages);
    //console.log('★ShopData : ' + pages)

    return (
        <>
        </>
    );


}

//export default ShopData;